import { useEffect, useState } from 'react'
import { getReportAttendanceDropSummaryStatusAPI } from '../../../services/report/attendanceSum'
import { t } from 'i18next'

function UseReportAttendanceDropSummaryStatus() {
  const [options, setOptions] = useState([])
  const [rawData, setRawData] = useState([])

  useEffect(() => {
    let ignore = false
    const getData = async () => {
      const resp = await getReportAttendanceDropSummaryStatusAPI()
      if (ignore || !resp) return
      if (resp.status) {
        setRawData(resp.result)
        const newData = resp.result.map((d) => ({
          value: d?.value,
          label: t(d?.value)
        }))
        setOptions(newData)
      } else {
        setOptions([])
        setRawData([])
      }
    }

    getData()

    return () => {
      ignore = true
    }
  }, [])

  return { options, rawData }
}

export default UseReportAttendanceDropSummaryStatus
